var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 36.6682C29.2051 36.6682 36.6674 29.206 36.6674 20.0009C36.6674 10.7957 29.2051 3.33348 20 3.33348C10.7949 3.33348 3.33262 10.7957 3.33262 20.0009C3.33262 29.206 10.7949 36.6682 20 36.6682ZM20 40.0017C31.0462 40.0017 40.0009 31.047 40.0009 20.0009C40.0009 8.95469 31.0462 0 20 0C8.95383 0 -0.000854492 8.95469 -0.000854492 20.0009C-0.000854492 31.047 8.95383 40.0017 20 40.0017Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9C21.1046 9 22 9.89543 22 11V23C22 24.1046 21.1046 25 20 25C18.8954 25 18 24.1046 18 23V11C18 9.89543 18.8954 9 20 9Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29C22 30.1046 21.1046 31 20 31C18.8954 31 18 30.1046 18 29C18 27.8954 18.8954 27 20 27C21.1046 27 22 27.8954 22 29Z",
    fill: "black"
  })));
};
export default SvgAlert;